import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Producto } from "../../../_models/producto";
import { Requisito } from "../../../_models/requisito";
import { ConfirmationService, SelectItem } from "primeng/api";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NavService } from "../../../_services/_nav.service";
import { ProductoService } from "../../../_services/producto.service";
import { forkJoin, Subscription } from "rxjs";
import { RequisitosGarantiasProductos } from "../../../_models/requisito-garantia-producto";
import { RequisitosGarantiasProductosService } from "../../../_services/requisitos-garantia-producto.service";
import { RequisitoRespaldo } from "../../../_models/requisito-respaldo";
import { RequisitosRespaldosService } from "../../../_services/requisitos-respaldos.service";
import { CanalComunicacion } from "../../../_enums/enum";
import { ComunicationComponentsService } from "../../../_services/comunication-components.service";

@Component({
  selector: "app-requisito-producto",
  templateUrl: "./requisito-producto.component.html",
  styleUrls: ["./requisito-producto.component.css"],
})
export class RequisitoProductoComponent implements OnInit {
  @Input() requisito: Requisito;
  @Output() dismiss: EventEmitter<boolean> = new EventEmitter<boolean>();

  lisProductosTodos: Producto[] = [];
  lisProductos: SelectItem[] = [];
  lisRequisitoProducto: RequisitosGarantiasProductos[] = [];
  lisRequisitoProductoTodos: RequisitosGarantiasProductos[] = [];
  columnas: any[] = [];
  formulario: FormGroup;
  cargando = true;
  submitted = false;
  lisRequisitoRespaldo: RequisitoRespaldo[] = [];
  lisRequisitoRespaldoTodos: RequisitoRespaldo[] = [];
  subscription: Subscription;

  constructor(
    private navService: NavService,
    private fb: FormBuilder,
    private conService: ConfirmationService,
    private productosService: ProductoService,
    private requisitosProductoService: RequisitosGarantiasProductosService,
    private requisitosRespaldosServicio: RequisitosRespaldosService,
    private communicationService: ComunicationComponentsService,
  ) {}

  ngOnInit() {
    /* Columnas para el data table */
    this.columnas = [
      {
        field: "productos",
        header: this.navService.buscarMensaje("REQUISITOS.LBL_PRODUCTO"),
        sort: false,
      },
      {
        field: "det",
        header: this.navService.buscarMensaje("LBL_ACCIONES"),
        sort: false,
      },
    ];

    forkJoin(this.productosService.listadoHabilitados()).subscribe(([productos]) => {
      productos = productos.sort(function (a, b) {
        return a.orden - b.orden;
      });
      this.lisProductosTodos = productos;
      this.cargarListado();
      this.cargarListadoRequisitoRespaldo();
      this.cargarFormulario();
      this.conectarCanal();
      this.cargando = false;
    });
  }

  conectarCanal() {
    this.subscription = this.communicationService.emisorComponent$.subscribe( async mensaje => {
      if ( mensaje.canal === CanalComunicacion.ACTUALIZARREQUISITORESPALDO && mensaje.mensaje &&
        mensaje.mensaje.accion ) {
          this.cargarListadoRequisitoRespaldo();
      }
    } );
  }

  /* Carga del listado de productos seleccionados */
  cargarListado() {
    this.lisRequisitoProducto = [];

    this.requisitosProductoService
      .obtenerPorIdRequisitoGarantia(this.requisito.idRequisitoGarantia)
      .subscribe((lisRequisitoProducto) => {
        this.lisRequisitoProductoTodos = lisRequisitoProducto;
        this.lisRequisitoProductoTodos.map((s) => {
          if (s.indicadorHabilitado) {
            this.lisRequisitoProducto.push(s);
          }
        });
        this.lisRequisitoProducto = [ ...this.lisRequisitoProducto ];
        this.cargarFiltros();
      });
  }

  cargarListadoRequisitoRespaldo() {
    this.lisRequisitoRespaldo = [];
    this.requisitosRespaldosServicio
      .obtenerPorIdRequisito(this.requisito.idRequisitoGarantia)
      .subscribe((lisRequisitosRespaldo) => {
        this.lisRequisitoRespaldoTodos = lisRequisitosRespaldo;
        this.lisRequisitoRespaldoTodos.map((s) => {
          if (s.indicadorHabilitado) {
            this.requisitosRespaldosServicio
              .obtenerPorGenerateList(s.idRequisitoGarantiaRespaldo)
              .subscribe((data) => {
                if (
                  data &&
                  data.requisitosGarantiasRespaldosTiposVinculaciones
                ) {
                  s.requisitosGarantiasRespaldosTiposVinculaciones =
                    data.requisitosGarantiasRespaldosTiposVinculaciones;
                  if (
                    data.requisitosGarantiasRespaldosTiposVinculaciones.length >
                    45
                  ) {
                    s.tiposVinculaciones = data.requisitosGarantiasRespaldosTiposVinculaciones.substring(
                      0,
                      45
                    );
                    s.verMasTiposVinculaciones = true;
                  } else {
                    s.tiposVinculaciones =
                      data.requisitosGarantiasRespaldosTiposVinculaciones;
                    s.verMasTiposVinculaciones = false;
                  }
                }
                if (data && data.requisitosGarantiasRespaldosActividades) {
                  s.requisitosGarantiasRespaldosActividades =
                    data.requisitosGarantiasRespaldosActividades;
                  if (
                    data.requisitosGarantiasRespaldosActividades.length > 45
                  ) {
                    s.actividades = data.requisitosGarantiasRespaldosActividades.substring(
                      0,
                      45
                    );
                    s.verMasActividades = true;
                  } else {
                    s.actividades =
                      data.requisitosGarantiasRespaldosActividades;
                    s.verMasActividades = false;
                  }
                }
                if (data && data.requisitosGarantiasRespaldosProductos) {
                  s.requisitosGarantiasRespaldosProductos =
                    data.requisitosGarantiasRespaldosProductos;
                  if (data.requisitosGarantiasRespaldosProductos.length > 45) {
                    s.productos = data.requisitosGarantiasRespaldosProductos.substring(
                      0,
                      45
                    );
                    s.verMasProductos = true;
                  } else {
                    s.productos = data.requisitosGarantiasRespaldosProductos;
                    s.verMasProductos = false;
                  }
                }
                this.lisRequisitoRespaldo.push(s);
              });
          }
        });
      });
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idRequisitoProducto: [null],
      idRequisitoGarantia: [
        this.requisito.idRequisitoGarantia,
        [Validators.required],
      ],
      idProducto: [null, [Validators.required]],
      indicadorHabilitado: [true],
    });
  }

  /* Filtrar la lista para el select */
  cargarFiltros() {
    this.lisProductos = [];

    this.lisProductosTodos.forEach((e) => {
      if (
        !this.lisRequisitoProducto.find((x) => x.idProducto === e.idProducto && x.indicadorHabilitado)
      ) {
        this.lisProductos.push({
          label: "[" + e.codigo + "] " + e.nombre,
          value: e.idProducto,
        });
      }
    });
  }

  async onSubmit() {
    this.submitted = true;

    if (!this.formulario.valid) {
      return;
    }

    this.cargando = true;
    const registro = this.formulario.value;
    let producto = {} as RequisitosGarantiasProductos;
    producto.indicadorHabilitado = true;
    producto.idRequisitoGarantia = this.requisito.idRequisitoGarantia;
    producto.idProducto = registro.idProducto;
    const existe = this.lisRequisitoProductoTodos.find(
      (x) => x.idProducto === registro.idProducto
    );

    if (existe) {
      producto.idRequisitoGarantiaProducto = existe.idRequisitoGarantiaProducto;
    }

    const requisitoProducto = await (existe
      ? this.requisitosProductoService.crear(producto)
      : this.requisitosProductoService.actualizar(producto)
    ).toPromise();

    this.reiniciar();
  }

  /* Controls formulario */
  get f() {
    return this.formulario.controls;
  }

  inhablitar(registro: RequisitosGarantiasProductos) {
    let denegarInhabilitar = 0;
    this.lisRequisitoRespaldo.map((x) => {
      if (x.productos) {
        if (x.productos.includes(registro.nombreProducto)) {
          denegarInhabilitar++;
        }
      }
    });

    if (denegarInhabilitar > 0) {
      this.conService.confirm({
        message: this.navService.buscarMensaje("REQUISITOS.LBL_NOSEPUEDEINHABILIDAR"),
        header: this.navService.buscarMensaje("LBL_CONFIRMACION"),
        icon: "fa fa-question-circle",
        key: `producto-requisito`,
        reject: () => {},
      });
    } else {
      this.conService.confirm({
        message: this.navService.buscarMensaje("MSG_INHABILITAR"),
        header: this.navService.buscarMensaje("LBL_CONFIRMACION"),
        icon: "fa fa-question-circle",
        key: `producto`,
        accept: () => {
          this.cargando = true;
          registro.indicadorHabilitado = false;
          this.requisitosProductoService.actualizar(registro).subscribe((r) => {
            this.navService.setMesage(2);
            this.cargarListado();
            this.cargando = false;
          });
        },
        reject: () => {},
      });
    }
  }

  reiniciar() {
    this.cargarListado();
    this.reiniciarForm();
    this.navService.setMesage(1);
    this.cargando = false;
  }

  reiniciarForm() {
    this.submitted = false;
    this.formulario.markAsPristine();
    this.cargarFormulario();
  }
}
